import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PostRow = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const userId = user.data.id;
  const paymentCards = user.data.bankingInfo.paymentCards;
  const depositAccounts = user.data.bankingInfo.depositAccounts;
  const { primaryCurrency, secondaryCurrency, amount, rate, post, onClick } =
    props;

  return (
    <tr>
      <td>{`Buy ${secondaryCurrency} with ${primaryCurrency}`}</td>
      {/* <td>{account}</td> */}
      <td className="text-danger">{`${amount} ${secondaryCurrency}`}</td>
      <td>{`${parseFloat((amount * rate).toFixed(2))} ${primaryCurrency}`}</td>
      {paymentCards.length === 0 || depositAccounts.length === 0 ? (
        <button
          type="button"
          className="btn btn-secondary btn-block"
          onClick={() => navigate("/settingsAccount")}
        >
          {t("setup.before.trade.label")}
        </button>
      ) : post.user_id === userId ? (
        <button
          type="button"
          className="btn btn-success btn-block"
          onClick={() => onClick("modify")}
        >
          {t("modify.label")}
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-success btn-block"
          onClick={() => onClick("buy")}
        >
          {t("buy.label")}
        </button>
      )}
    </tr>
  );
};

export default PostRow;
